import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import ScrollToTop from './components/common/ScrollToTop'
import * as Pages from './pages'

const AppRouter: React.FC = () => {
  return (
    <Router basename="/ccpa">
      <ScrollToTop />
      <Switch>
        <Route exact path="/" component={Pages.HomePage}></Route>
        <Route exact path="/consumer-info" component={Pages.ConsumerInfoPage}></Route>
        <Route exact path="/agent-info" component={Pages.AgentInfoPage}></Route>
        <Route exact path="/confirm" component={Pages.ConfirmationPage}></Route>
      </Switch>
    </Router>
  )
}

export default AppRouter
